var map = {
	"./ametista.png": "ea18",
	"./black-diamond.png": "df5c",
	"./blue-diamond.png": "2763",
	"./diamante.png": "50dc",
	"./duplo-diamante.png": "0a53",
	"./esmeralda.png": "2321",
	"./imperial-diamond.png": "b0d2",
	"./opala.png": "80dd",
	"./platina.png": "5737",
	"./prime.png": "6e3a",
	"./red-diamond.png": "4842",
	"./triplo-diamante.png": "98cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee0";